module.exports = __webpack_public_path__ + "img/enaira-light.66935c0a.svg";